export default __webpack_public_path__ + "static/knife-fb1742a493cd655350f8a3dec4c55c32.png";